var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import SourceCodeService from '../../api/SourceCodeService';
import { EPurOrderStatus, EShipStatus } from "../../enum/EStatus";
function tidyDepotList(treeData) {
    treeData.forEach(function (item) {
        item.isDisabled = true;
    });
}
var PurOrderHeader = (function (_super) {
    __extends(PurOrderHeader, _super);
    function PurOrderHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.purOrderStatus = EPurOrderStatus;
        _this.formData = {};
        _this.importFormData = {};
        _this.placeHolder = ['', '请输入订货单号', '货品名称/首字母/编码'];
        _this.dimensionType = [{ label: "按门店货品", value: "1" }, { label: "按货品门店", value: "2" }, { label: "按货品", value: "3" }];
        _this.printNumType = [{ label: "0", value: "0" }, { label: "1", value: "1" }];
        _this.eShipStatus = EShipStatus;
        _this.isMoreSearch = false;
        _this.shipStatusList = [{ name: "全部", value: "-1" }, { name: "待发货", value: EShipStatus.NoShip }, { name: "部分发货", value: EShipStatus.PartShip }];
        _this.splitStatusList = [
            { name: "全部", value: -1 },
            { name: "否", value: 0 },
            { name: "是", value: 1 }
        ];
        _this.billsSource = [];
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.splitOrderStatus = {
            success: 0,
            client: 1,
            store: 2,
            Inventory: 3,
            begin: 4,
            goods: 8,
        };
        _this.dialogAuditImportVisible = false;
        _this.templateList = [];
        _this.templateDownUrl = '';
        _this.organBusiness = [];
        _this.err_codes = [42, 43, 44, 45];
        return _this;
    }
    PurOrderHeader.prototype.created = function () {
        this.service = SourceCodeService.getInstance();
    };
    PurOrderHeader.prototype.mounted = function () {
        this.initData();
        this.search();
        console.log(this.data, "====");
    };
    PurOrderHeader.prototype.initData = function () {
        this.formData = {
            order_ids: this.data.orderIds || "",
            keyword: '',
            dimension: "1",
            printNum: "1",
        };
    };
    PurOrderHeader.prototype.resetData = function () {
        this.initData();
        this.search();
    };
    PurOrderHeader.prototype.printData = function (val) {
    };
    PurOrderHeader.prototype.resetFormData = function () {
        this.formData = {
            order_ids: this.data.orderIds || "",
            dimension: "1",
            keyword: "",
            printNum: "1",
        };
    };
    PurOrderHeader.prototype.dimensionChange = function () {
        this.$emit('search', this.formData);
    };
    PurOrderHeader.prototype.printNumChange = function () {
        this.$emit('search', this.formData);
    };
    PurOrderHeader.prototype.search = function () {
        this.$emit('search', this.formData);
        this.resetFormData();
    };
    PurOrderHeader.prototype.limitNum = function () {
        this.formData.printNum = this.formData.printNum.replace(/[^\d]/g, '');
        this.formData.printNum = this.formData.printNum.replace(/^(\d{0,3}).*$/g, '$1');
    };
    __decorate([
        Prop({
            type: Object
        })
    ], PurOrderHeader.prototype, "data", void 0);
    PurOrderHeader = __decorate([
        Component({
            methods: {},
            computed: {},
            components: {}
        })
    ], PurOrderHeader);
    return PurOrderHeader;
}(Vue));
export default PurOrderHeader;
